export const VisualConnector = () => (
  <div className="flex justify-center" aria-hidden="true">
    <div className="flex flex-col items-center">
      <div className="w-2.5 h-2.5 rounded-full bg-primary-500 -translate-y-1/2" />
      <div className="w-0.5 h-16 bg-primary-500 -mt-[5px]" />
      <svg width="12" height="10" viewBox="0 0 12 10">
        <path
          d="M6 10L0 0h12L6 10z"
          fill="currentColor"
          className="text-primary-500"
        />
      </svg>
    </div>
  </div>
);
